<div class="korisnici-page">

    <div class="korisnici-page__container">
        <korisnici-tablica *ngIf="korisnici" [korisnici]="korisnici"></korisnici-tablica>
    </div>

</div>
